import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExternalPrescription } from '@models/prescriptions/external-prescription';
import { Prescription } from '@models/prescriptions/prescription';
import { PatientService } from '@services/patient.service';
import { ExternalPrescriptionService } from '@services/prescriptions/external-prescription.service';
import { PrescriptionService } from '@services/prescriptions/prescription.service';

@Component({
  selector: 'app-external-prescriptions',
  templateUrl: './external-prescriptions.component.html',
  styleUrls: ['./external-prescriptions.component.less'],
})
export class ExternalPrescriptionsComponent implements OnInit, OnChanges {
  public prescriptionList: Prescription[];
  private externalPrescriptionList: ExternalPrescription[];
  public externalPrescriptionEntry: ExternalPrescription;
  @Input() panelHeight: number;
  @Input() patientId: number;
  constructor(
    private prescriptionService: PrescriptionService,
    private externalPrescriptionService: ExternalPrescriptionService,
    private patientService: PatientService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {    
    if (!this.patientId) {
      this.patientId = this.route.snapshot.params.patId.split('_')[0];
    }
    this.getExternalPrescriptionsByPatientId();
  }

  ngOnChanges() {
    this.getExternalPrescriptionsByPatientId();
  }

  public getExternalPrescriptionsByPatientId() {
    if (this.patientId) {
      this.externalPrescriptionService.getExternalPrescriptionsByPatientId(this.patientId).subscribe((res) => {
        this.externalPrescriptionList = res;
        this.externalPrescriptionEntry = this.externalPrescriptionList.length
          ? this.externalPrescriptionList[0]
          : new ExternalPrescription({
              description: '',
              patientId: this.patientService.patientPanelPatient
                ? this.patientService.patientPanelPatient.patientId
                : this.patientId
                ? this.patientId
                : 0,
            });
        if (this.externalPrescriptionList.length > 1) {
          const concatenatedDescriptions = this.externalPrescriptionList
            .map((prescription) => prescription.description)
            .join('\r\n');
          this.externalPrescriptionEntry.description = concatenatedDescriptions;
        }
      });
    }
  }

  public addExternalPrescription(entry: string) {
    this.externalPrescriptionEntry.description = entry;
    if (this.externalPrescriptionEntry.id) {
      this.updateExternalPrescription(this.externalPrescriptionEntry);
    } else {
      this.externalPrescriptionService
        .addExternalPrescription(this.externalPrescriptionEntry)
        .subscribe((externalRx: ExternalPrescription) => {
          this.externalPrescriptionEntry = externalRx;
        });
    }
  }

  public updateExternalPrescription(item: ExternalPrescription) {
    this.externalPrescriptionService.updateExternalPrescription(item).subscribe(() => {});
  }
}
